<template>
    <component
        :is="url ? 'a' : 'div'"
        class="scientific-tracks-card"
        target="_blank"
        rel="noopener noreferrer"
        :href="url"
        :style="`background-color: ${color};`"
    >
        <h4 class="scientific-tracks-card__title">
            <slot name="title" />
        </h4>

        <div class="scientific-tracks-card__text">
            <slot />
        </div>
    </component>
</template>

<script setup>
defineProps({
    url: {
        type: String,
        required: true
    },
    color: {
        type: String,
        required: false,
        default: 'var(--color-primary-light)'
    }
});
</script>

<style lang="less">
.scientific-tracks-card {
    .link-clean();

    display: flex;
    flex-direction: column;
    padding: 1rem .75rem;
    width: 100%;
    gap: .25rem;
    border-radius: var(--borderRadius-xs);

    @media @q-md-min {
        padding: 2.1875rem 1.5rem;
    }
}

a.scientific-tracks-card {
    transition: filter var(--transition-fast);

    &:hover,
    &:active {
        filter: brightness(90%);
    }

    &:focus {
        box-shadow: var(--boxShadow-outline);
    }

    &:active {
        filter: brightness(95%);
    }
}

.scientific-tracks-card__title {
    .typography-h4();
    color: var(--color-primary-dark);
}

.scientific-tracks-card__text {
    .typography-text();

    display: flex;
    align-items: center;
    margin: 0;
    color: var(--color-primary-dark);

    .dn-icon {
        font-size: 1.25em;
        margin-left: 0.25rem;
    }
}
</style>
